/*global UploaderForm, Backbone, _, $ */
'use strict';

var Backbone        = require('backbone');
var $               = require('jquery');
var _               = require('lodash');
var BackboneValidation = require('backbone-validation');

var template        = require('./../tmp/templates');
var CSSView         = require('./css');

module.exports = Backbone.View.extend({
    css: template['form.css'],
    template: template['form'],
    tagName: 'div',

    className: 'view-wc-form',

    events: {
        'submit .uploader-form': 'handleFormSubmit',
        'keydown .input-age': 'disableNonNumeric',
        'click .reset': 'resetForm'
    },

    /**
     *
     */
    initialize: function(options) {
        _.bindAll(this, 'render', 'resetForm', 'handleInvalid', 'handleFieldValueChange', 'handleModelSync');
        console.log('FORM: initialize');
        this.static_copy = options.static_copy;
        BackboneValidation.bind(this, {
           model: this.model
        });

        this.listenTo(this.model, 'validated:invalid', this.handleInvalid);
        this.listenTo(this.model, 'change', this.handleFieldValueChange);

        //This is must be triggered manually in the router or wherever.
        this.listenTo(this.model, 'sync', this.handleModelSync);

        this.style_id =  this.className + _.uniqueId();
        this.$el.addClass(this.style_id);
        this.uid = options.uid;

        this.static_copy = options.static_copy || {};

        this.user = options.user;
        this.useFB = options.useFB;
    },
    /**
     *
     */
    handleFieldValueChange: function() {
        console.log('FORM: handleFieldValueChange');
        var changed = this.model.changedAttributes();

        _.each(changed, _.bind(function(value, key) {
            var field = this.$('[name="' + key + '"]');
            var type = field.prop('type');

            switch(type) {
                case 'file':
                    this.clearFileUpload(field);
                    break;
                case 'checkbox':
                    field.prop('checked', value === true);
                    break;
                default:
                    field.val(value);
            }

        }, this));
    },
    /**
     *
     */
    handleFormSubmit: function(e) {
        console.log('FORM: handleFormSubmit');
        e.preventDefault();

        var params = {};
        var form = this.$('.uploader-form');
        _.each(form.serializeArray(), function(data) {
            params[data.name] = data.value;
        });

        _.each(form.find('input:checkbox'), function(data){
            params[data.name] = data.checked ? "true" : "false";
        });

        _.each(this.$('input[type="file"]'), function(data) {
            params[data.name] = data.value;
        });

        this.model.set(params, { silent: true });

        this.disableForm();
        this.model.save();
    },

    /**
     *
     */
    disableForm: function() {
        console.log('FORM: disableForm');
        this.$('form :input').attr('disabled', true);
    },

    /**
     *
     */
    enableForm: function() {
        console.log('FORM: disableForm');
        this.$('form :input').attr('disabled', false);
        this.$('.file-combo-text input').attr('disabled', true);
    },

    /**
     *
     */
    render: function() {
        console.log('FORM: render');
        if(this.CSSView) {
            this.CSSView.remove();
        }

        this.CSSView = new CSSView({ 
            model: this.static_copy.customizations, 
            namespace: '#' + this.uid + ' .' + this.style_id,
            template: 'form.css'
        });

        Backbone.$('head').append(this.CSSView.render().$el);

        var fields = this.model.getFieldData();
        var uniqueId = Math.round(Math.random() * 1000000);
        _.each(fields, function(field) {
            field.uniqueId = field.id + '_' + uniqueId;
        });

        var params = {
            'fields': fields,
            user : this.user,
            useFB: this.useFB
        };

        _.extend(params, this.static_copy);

        this.$el.html(this.template(params));

        this.setupFileUploadCombos();
        this.setupTextCounters();
        return this;
    },

    /**
     *
     */
    renderedToDOM: function() {
        console.log('FORM: renderedToDOM');
        //Check for an error only on blur (unfocus).
        this.$('input,textarea,select,button').on('blur', _.bind(this.handleBlurValidation, this));

        //If something is marked with .has-error, check constantly so we can clear the error message as soon as possible.
        this.$el.on('change blur input', '.has-error :input,.has-error :file', _.bind(this.handleBlurValidation, this));
    },

    disableNonNumeric: function(e){
        // 48 to 57 - 0 to 9
        // 8 - backspace / delete
        // 9 - tab key
        //if((e.keyCode < 48 && e.keyCode != 8 && e.keyCode != 9) || e.keyCode > 57) e.preventDefault();
    },

    /**
     *
     */
    handleBlurValidation: function(e) {
        console.log('FORM: handleBlurValidation');
        var field = $(e.target);
        var value = field.val();
        if(field.prop('type').toLowerCase() === 'checkbox') {
            value = field.is(':checked');
        }else if(field.prop('type').toLowerCase() === 'number'){
            // maxlength property doesn't work on input type=number
            var maxAge = field.prop('max');
console.log(parseInt(value), value.length, "onblur");
            if(parseInt(value) > parseInt(maxAge) || value.length > 3) field.val(maxAge);
        }else if(field.prop('type').toLowerCase() === 'file'){
            if(value.length === 0) return;
        }
        var error = this.model.preValidate(field.prop('name'), value);

        if (error) {
            var errors = {};
            errors[field.prop('name')] = error;
            this.renderErrors(errors);
        } else {
            field.closest('.form-group').removeClass('has-error').find('.error-message').remove();
        }
    },

    /**
     *
     */
    handleInvalid: function(model, errors) {
        console.log('FORM: handleInvalid');
        $('.has-error').removeClass('has-error').find('.error-message').remove();

        this.enableForm();
        this.renderErrors(errors);
    },

    /**
     *
     */
    renderErrors: function(errors) {
        console.log('FORM: renderErrors');
        _.each(errors, function(error, name) {
            var el = $('<div class="error-message">' + error + '</div>');
            var parent = $('[name="' + name + '"]').closest('.form-group');

            if (parent.addClass('has-error').find('.error-message').length === 0) {
                parent.append(el);
            }
        });
    },

    /**
     *
     */
    setupFileUploadCombos: function() {
        console.log('FORM: setupFileUploadCombos');
        this.$('.file-combo input[type="file"]').change(_.bind(this.handleFileUploadChange, this));
        this.$('.file-combo .btn-close').click(_.bind(this.handleFileUploadClear, this)).hide();
    },

    handleFileUploadChange: function(e) {
        console.log('FORM: handleFileUploadChange');
        var file = $(e.currentTarget);
        var path = file.val();
        var name = path.replace(/.*(\/|\\)/, '');
        var close = file.closest('.file-combo').find('.btn-close');
        file.closest('.file-combo').find('input[type="text"]').val(name);
        if (path === '') {
            close.hide();
        } else {
            close.show();
        }

        //Firefox needs this.
        this.handleBlurValidation(e);
    },

    clearFileUpload: function(fileElement) {
        console.log('FORM: clearFileUpload');
        var btn = $(fileElement);
        var fileCombo = btn.closest('.file-combo');
        var file = fileCombo.find('input[type="file"]').get(0);

        $(file).wrap('<form>').closest('form').get(0).reset();
        $(file).unwrap();

        fileCombo.find('input[type="text"]').val('');
        fileCombo.find('.btn-close').hide();
    },

    handleFileUploadClear: function(e) {
        console.log('FORM: handleFileUploadClear');
        this.clearFileUpload(e.currentTarget);
    },

    /**
     * Sets up listeners for all of the character counters on the page.
     */
    setupTextCounters: function() {
        console.log('FORM: setupTextCounters');
        this.$('.has-counter input, .has-counter textarea')
            .on('change keyup input propertychange', _.bind(this.onCounterUpdate, this))
            .focus(function(e) {
                $(this).parent().addClass("input-group-focus");
            })
            .blur(function(e) {
                $(this).parent().removeClass("input-group-focus");
            });
    },

    /**
     *
     */
    onCounterUpdate: function(e) {
        console.log('FORM: onCounterUpdate');
        var field = $(e.currentTarget);
        var len = field.val().length;
        var max = field.prop('maxlength');
        var counter = $(e.currentTarget).next('.input-group-counter');

        counter.text(Math.abs(max - len));
    },

    handleModelSync: function(model) {
        console.log('FORM: handleModelSync');
        var fieldOptions = this.model.getFieldData();
        var attrs = {};

        for(var i = 0; i < fieldOptions.length; i++) {
            var field = fieldOptions[i];
            if(field.clear_on_submit === 'true') {
                if(field.type === 'checkbox') {
                    attrs[field.id] = false;
                } else {
                    attrs[field.id] = '';
                }
            }
        }
        this.model.set(attrs);

        this.enableForm();
    },
    fbShare: function(e) {
        e.preventDefault();
        this.trigger("facebookShare", {
            share: true
        });
    },

    /**
     *
     */
    resetForm: function(e) {
        console.log('FORM: resetForm');
        if (e) {
            e.preventDefault();
        }
        this.$('.file-combo .btn-close').hide();

        // this.$('.uploader-form').reset();
		this.$('.uploader-form')[0].reset();
        this.$(".checkbox, label").removeClass("active");
    },

    /**
     *
     */
    remove: function() {
        console.log('FORM: remove');
        if(this.CSSView) {
            this.CSSView.remove();
        }

        this.$('input,textarea,select,button').off('change keyup input propertychange');

        return Backbone.View.prototype.remove.call(this);
    }
});
